//import update from 'immutability-helper';

const emptyState = {
  data: {}
}

const ExamplesReducer = (state = emptyState, action) => {
  switch (action.type) {
    case "EXAMPLES_INIT": {
      let newData = JSON.parse(JSON.stringify(action.payload));
      return {...state, data: newData};
    }
    default: {
      return state
    }
  }
}

export default ExamplesReducer